import { render, staticRenderFns } from "./CreateTableModal.vue?vue&type=template&id=3f3365e9&scoped=true&"
import script from "./CreateTableModal.vue?vue&type=script&lang=ts&"
export * from "./CreateTableModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3365e9",
  null
  
)

export default component.exports